import styled from 'vue3-styled-components';

export const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 16px; 
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 25px;
  font-weight: bold;
  color: #cc5803;
  margin-bottom: 20px;
`;

export const TimeInfo = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 12px;
  margin-bottom: 25px;
  width: 100%;
`;

export const TimeItem = styled.span`
  color: #555;
  font-size: 15px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 20px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  justify-content: center;

  label {
    font-size: 17px;
    min-width: 80px;
    text-align: right;
    margin-right: 10px;
  }

  .value-box {
    background-color: #f8f9fa;
    padding: 8px 10px;
    border-radius: 8px;
    width: 120px;
    height: 20px;
    min-width: 120px;
    display: flex;
    align-items: center;
    color: #007bff;
    font-weight: 600;
    border: 1px solid #edf0f2;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transition: all 0.2s ease;

    &:hover {
      background-color: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
      transform: translateY(-1px);
    }
  }
    
  input {
    padding: 8px 10px;
    border-radius: 8px;
    height: 20px;
    width: 150px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    font-size: 16px;
    
    &:hover {
      background-color: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
    }

    &:focus {
      background-color: #fff;
      border-color: #007bff;
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }
  }

  select {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #ddd;
    color: #333;
    cursor: pointer;
    font-size: 15px;

    option {
      background-color: #fff;
      color: #333;
      padding: 8px;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }
`;

export const CustomCheckbox = styled.label`
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 8px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ .checkmark {
      background-color: #fb8b24;
      border-color: #fb8b24;

      &:after {
        display: block;
      }
    }
  }
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #ddd;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:hover {
    border-color: #fb8b24;
  }
`;

export const CheckboxLabel = styled.span`
  font-size: 17px;
  font-weight: bold;
  color: #333;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin: 25px 0;
`;

const BaseButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  color: white;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const SubmitButton = styled(BaseButton)`
  background: linear-gradient(135deg, #0052CC 0%, #2684FF 100%);
  padding: 10px 20px;
  min-width: 100px;
  
  &::before {
    margin-right: 8px;
    font-size: 1.1rem;
  }
`;

export const CloseButton = styled(BaseButton)`
  background: linear-gradient(135deg, #666666 0%, #999999 100%);
  padding: 10px 20px;
  min-width: 100px;
  
  &::before {
    margin-right: 8px;
    font-size: 1.1rem;
  }
`;